import * as XLSX from 'xlsx';

// Общий помощник для выгрузки любой таблицы в .xlsx: headers — подписи столбцов,
// rows — массив массивов ячеек в том же порядке. Используется и встроенной кнопкой
// экспорта в DataTable, и страницами с собственной вёрсткой таблицы (без DataTable).
export function downloadExcel(filename, headers, rows) {
  const sheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, 'Данные');
  XLSX.writeFile(book, `${filename}.xlsx`);
}
